module.exports = __webpack_public_path__ + "resources/img/img_db-i_cloud01-m-jp.b0ec85f3279fb54677783e5e2711fcf8.png";